import tags from "../../components/tags";
import { icons } from "../../components/html";
import { statusCodes } from "../../components/responses";

export default {
  "/fits": {
    get: {
      tags: [tags.sizeIdDatabase],
      summary: " Fits - fit rates",
      description: `${icons.c}
      Returns a list of used fits, ie information on how the recommended size fits the user in specified measure.`,
      parameters: [{ $ref: "#/components/parameters/acceptsLanguages" }],

      responses: {
        "200": {
          content: {
            "application/json": {
              schema: {
                type: "array",
                items: {
                  $ref: "#/components/schemas/fit"
                }
              }
            }
          }
        },
        ...statusCodes
      }
    }
  }
};
